import React from 'react';
// 1. Import komponen dari library BARU
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { thumbnailPlugin } from '@react-pdf-viewer/thumbnail';

// 2. Import CSS wajib dari library BARU
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '@react-pdf-viewer/thumbnail/lib/styles/index.css';

// 3. Import CSS custom kita untuk tema gelap
import './PdfViewerCustom.css';

// Import komponen Modal dasar kita
import Modal from './Modal';

const PdfViewerModal = ({ show, onClose, fileUrl, size, title }) => {
  // Inisialisasi plugin thumbnail
  const thumbnailPluginInstance = thumbnailPlugin();
  const { Thumbnails } = thumbnailPluginInstance;

  // Inisialisasi plugin layout default (untuk toolbar)
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: (defaultTabs) => [
      // Atur agar tab thumbnail muncul di posisi pertama
      defaultTabs[1], 
      defaultTabs[0],
    ],
  });

  if (!show || !fileUrl) {
    return null;
  }

  return (
    // Kita gunakan komponen Modal kita sebagai bingkai
    <Modal show={show} onClose={onClose} title={title} size={size}>
      <div className="pdf-viewer-in-modal">
        {/*
          4. Komponen Worker dengan properti 'workerUrl' yang benar.
          Versi '3.4.120' adalah versi yang kita install dan sudah stabil.
        */}
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
          <div style={{ display: 'flex', height: '100%' }}>
            {/* Sidebar untuk Thumbnail */}
            <div
              style={{
                borderRight: '1px solid rgba(0, 0, 0, 0.2)',
                width: '150px',
                overflowY: 'auto',
                backgroundColor: '#222222' // Warna latar sidebar thumbnail
              }}
            >
              <Thumbnails />
            </div>

            {/* Viewer Utama untuk Konten PDF */}
            <div style={{ flex: 1, overflow: 'hidden' }}>
              <Viewer
                fileUrl={fileUrl}
                plugins={[defaultLayoutPluginInstance, thumbnailPluginInstance]}
                theme="dark" // Mengaktifkan tema gelap
              />
            </div>
          </div>
        </Worker>
      </div>
    </Modal>
  );
};

export default PdfViewerModal;